/**
 * Default and per-route titles/descriptions for Layout + SeoHead.
 * Extend ROUTE_META as new marketing pages are added.
 */
const DEFAULT_META = {
  title: "Proppins — Buy & rent apartments, villas, and plots in India",
  description:
    "Search new launches, resale homes, and verified projects by city. Compare listings, explore localities, and contact builders on Proppins.",
};

const ROUTE_META = {
  "/": {
    title: "Proppins — Find your next home in Hyderabad and top Indian cities",
    description:
      "Browse apartments, villas, and plots with city-smart search, comparisons, and trusted project details.",
  },
  "/apts-home": {
    title: "Apartments for sale — new launches & listings | Proppins",
    description:
      "Explore apartment projects, editor’s picks, and locality insights. Filter by budget, BHK, and possession.",
  },
  "/villas-home": {
    title: "Villas for sale — luxury & gated communities | Proppins",
    description:
      "Discover villa projects and independent homes with photos, prices, and builder information.",
  },
  "/plots-home": {
    title: "Plots & land for sale — approved layouts | Proppins",
    description:
      "Find residential plots and plotted developments with location details and pricing.",
  },
  "/rent-apartments-home": {
    title: "Apartments for rent — furnished & unfurnished | Proppins",
    description:
      "Rent apartments across top localities. View listings with rent, configuration, and map context.",
  },
  "/rent-villas-home": {
    title: "Villas for rent — family homes | Proppins",
    description:
      "Browse rental villas and independent houses with photos and contact options.",
  },
  "/contact-us": {
    title: "Contact Proppins — sales & support",
    description: "Reach the Proppins team for listings, partnerships, and product feedback.",
  },
  "/about-company": {
    title: "About Proppins",
    description: "Learn about Proppins and how we help buyers and renters find the right property.",
  },
  "/how-we-show-listings": {
    title: "How we show listings | Proppins",
    description:
      "How Proppins displays projects, filters, and trust cues. Listings are for discovery; confirm details with the developer.",
  },
  "/apts-compare": {
    title: "Compare apartments side by side | Proppins",
    description: "Compare shortlisted apartment projects on price, size, and amenities.",
  },
  "/villas-compare": {
    title: "Compare villas side by side | Proppins",
    description: "Compare villa projects and make an informed shortlist.",
  },
  "/plots-compare": {
    title: "Compare plots & layouts | Proppins",
    description: "Compare plot options across projects and localities.",
  },
};

/**
 * @param {string} pathname
 * @returns {{ title: string, description: string }}
 */
export function getRouteMeta(pathname) {
  const p =
    typeof pathname === "string" && pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname || "/";
  return ROUTE_META[p] || DEFAULT_META;
}
